import React from 'react';
import { Controller, useFormContext, ValidationOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { validateRequired } from 'utils/form';
import { CustomInput, CustomInputProps } from './CustomInput';

interface CustomInputFieldProps extends CustomInputProps {
	validation?: ValidationOptions;
}

export const CustomInputField = ({
	name = '',
	onlyNumbers,
	validation = {},
	required,
	...props
}: CustomInputFieldProps) => {
	const { errors, control, watch } = useFormContext();
	const { t } = useTranslation('errors');

	return (
		<Controller
			control={control}
			name={name}
			rules={{
				...validateRequired(required, t('required')),
				...validation,
			}}
			as={
				<CustomInput
					name={name}
					error={errors[name]?.message || errors[name]?.types?.message}
					inputValue={watch(name)}
					required={required}
					onlyNumbers={onlyNumbers}
					{...props}
				/>
			}
		/>
	);
};
